const cancel = 'İptal et'
const save = 'Kaydet'

export default {

  global: {
    generalError: 'Üzgünüz! Talep işlenemedi. Lütfen sayfayı yenileyin.',
    signature: 'Saygılarımızla,',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
    },

    addButton: {
      add: 'Ekle',
    },

    attachments: {
      add: 'CV veya diğer istenen ekleri ekleyin',
      placeholderWithDescription: 'İstenen ekleri ekleyin',
      remove: 'Kaldır',
      allowedFileTypes: 'İzin verilen dosya türleri',
      errors: {
        size: 'Dosya çok büyük, dosya boyutu maksimum 5MB olmalıdır.',
        empty: 'Dosyada veri yok',
        invalidType: fileType => `Üzgünüz, ${fileType} dosyalarına güvenlik nedeniyle izin verilmiyor`,
        typeNotWhitelisted: 'Üzgünüz, bu dosya türüne izin verilmiyor.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Gizlilik politikamızı’ okuyun',
      termsLinkText: 'Hüküm ve koşulları',
      privacyPolicyText:
        'Gizliliğinize önem veriyoruz, lütfen kişisel verilerinizi bize vermeden önce ',
      termsText1: 'Şunu okuyup kabul edin: ',
      termsText2: 've ardından kişisel verilerinizi bizimle paylaşın.',
      privacyLink: 'https://new.recright.com/privacy-policy',
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Kişisel verilerinizi işlememizi istemiyorsanız, ${mail} adresine mesaj göndererek verilerinizin kaldırılmasını talep edebilirsiniz.`,
      customSupportPrivacyInfo: link => `Kişisel verilerinizi işlememizi istemiyorsanız, ${link} üzerinden iletişime geçerek verilerinizin kaldırılmasını talep edebilirsiniz.`,
    },

    buttons: {
      close: 'Kapat',
    },

    competencies: {
      addCompetency: 'Yeni bir yetkinlik ekle',
      edit: 'Yetkinlikleri düzenle',
      done: 'Tamam',
      defaultsDescription: 'Hangi yetkinlikleri kullanacağınızdan emin değilseniz, başlangıç için bazı iyi varsayılanlar tanımladık.',
      getDefaults: 'Varsayılanları al',
    },

    competency: {
      warning: 'Yetkinlik ve bu yetkinliğe ait tüm puanlar kaldırılsın mı?',
    },

    confirmDelete: {
      delete: 'Sil',
      cancel: 'İptal et',
      confirm: 'Onayla',
    },

    confirm: {
      cancel: 'Almayı kaldır',
      confirm: 'Tekrar dene',
    },

    confirmButton: {
      wait: count => `${count} bekleyin`,
      confirm: 'Onayla',
    },

    controlStatus: {
      text: {
        empty: 'Doldur',
        valid: () => 'Hazır',
      },
      textarea: {
        empty: 'Doldur',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Ayarla',
        valid: () => 'Hazır',
      },
      file: {
        empty: 'Seç',
        valid: () => 'Değiştir',
      },
      list: {
        empty: 'Ekle',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Ara',
        valid: () => 'Hazır',
      },
    },

    emailAddresses: {
      remove: 'Kaldır',
      importCsv: 'CSV\'yi içe aktar',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'E-posta geri döndü. Alıcının mesajınızı aldığından emin olun.',
      },
      Permanent: {
        General: 'E-posta gönderme başarısız oldu. Alıcının e-posta sağlayıcısı mesajı reddetti.',
        NoEmail: 'E-posta adresi mevcut değil.',
        Suppressed: 'Önceki başarısız gönderme denemeleri nedeniyle e-posta teslim edilemedi.',
      },
      Transient: {
        General: 'E-posta geri döndü. Alıcının mesajınızı aldığından emin olun.',
        MailboxFull: 'Alıcının gelen kutusu dolu.',
        MessageTooLarge: 'Mesaj içeriği çok büyük.',
        ContentRejected: 'Mesaj içeriği reddedildi.',
        AttachmentRejected: 'Ek reddedildi.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS mesajı mesaj kuyruğuna eklendi, gönderilmeyi bekliyor.',
      failed: 'SMS mesajı gönderilemedi.',
      duplicate: 'Verilen numara daha önce mülakattaki bir aday ile eşleştirilmiş.',
    },

    error403: {
      heading: 'Erişim engellendi',
      content: 'Lütfen doğru hesap ile oturum açtığınızdan ve Recright\'taki bu pozisyonu gözden geçirmeye davet edildiğinizden emin olun. Ayrıca Recright\'ı aynı anda tek tarayıcı penceresinde kullandığınızdan emin olun.',
      link: 'Ön sayfa',
    },

    error404: {
      heading: 'Hiçbir şey yok',
      content: 'Dikkatle baktık, fakat talep ettiğiniz adreste herhangi bir web sayfası mevcut değil. Linkin süresi dolmuş olabilir veya yanlışlıkla yanlış adres girmiş olabilirsiniz.',
      link: 'Ön sayfa',
    },

    error410: {
      heading: 'Kapalı',
      content: 'İş, kapatıldığı veya başvuru süresi sona erdiği için gösterilemiyor.',
      link: 'Ön sayfa',
    },

    calendarError: {
      heading: 'Takvime bağlanılamıyor',
      content: 'Takviminize bağlanamadık. Lütfen daha sonra tekrar deneyin. Sorun devam ederse, lütfen destek birimiyle iletişime geçin.',
    },

    flash: {
      starting: 'Başlatılıyor...',
      connection_error_hint: 'Ağ bağlantısı kurulamadı.\nSayfayı yenilemeyi deneyin.',
      permission_hint: 'Bu sitenin web kameranızı ve mikrofonunuzu kullanmasına izin vermeniz gerekiyor.',
      searching_camera_hint: 'Web kamerası aranıyor...',
      camera_reserved_hint: 'Web kameranız başka bir uygulama veya web sayfası tarafından kullanılıyor.\nLütfen o uygulamayı kapatın ve bu sayfayı yeniden yükleyin.',
      camera_reserved_hint_chrome_extra: '\n\nSayın Chrome kullanıcısı, adres çubuğunun altındaki iletişim kutusundan Recright\'ın Web kameranızı kullanmasına izin vermeniz gerekiyor.',
      no_camera_hint: 'Web kamerası bulunamadı.',
      no_mic_hint: 'Mikrofon bulunamadı.',
      uploading_text: 'Yükleniyor...',
      rtmpt_in_use: 'Ağınız yöneticiniz RTMP\'ye (Gerçek Zamanlı Mesajlaşma Protokolü) izin verseydi, \nbu adım gerekli olmayacaktı. Nasıl olduğunu öğrenmek için bizimle iletişime geçin.',
      preview_text: 'Web kamerası ön izleme modunda',
      close_text: 'Kamerayı kapat',
      remove_text: 'Almayı kaldır',
      noflash_errortext_install: link => `Cihazınızda Adobe Flash Player tespit edilemedi. Video kaydetmek için bir flash eklentisine ihtiyacınız var. Flash indirmek için tıklayın: ${link}`,
      noflash_errortext_enable: link => `Cihazınızda Flash yüklü olmasına rağmen yine de bu mesajı görüyorsanız, şu linke bakınız: ${link}`,
      noflash_errortext_differentbrowser: 'Alternatif olarak, HTML5 kaydını destekleyen bir tarayıcı kullanmayı deneyebilirsiniz. Chrome veya Firefox kullanmanızı öneririz.',
    },

    footer: {
      terms: 'Şartlar',
      license: 'General Terms of Service',
      privacyPolicy: 'Gizlilik politikası',
      customSupport: link => `İletişim için tıklayın: ${link}`,
      accessibilityReport: 'Erişilebilirlik raporu',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Mülakat deneyiminizi nasıl değerlendirirsiniz?',
      howWouldYouRateJobAd: 'Başvuru deneyiminizi nasıl değerlendirirsiniz?',
      yourResponseIsAnonymous: 'Yanıtınız anonimdir.',
      thankYouFeedback: 'Geri bildiriminiz için teşekkür ederiz!',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    cookieConsentModal: {
      title: 'Web sitemizde çerezler kullanılmaktadır',
      body: 'Tüm çerezleri kabul ederek, çerezlerin, sitede gezinmeyi iyileştirmek, site kullanımını analiz etmek ve pazarlama çalışmalarımıza yardımcı olmak amacıyla cihazınızda depolanmasına onay verirsiniz.',
      learnMoreLinkText: 'Çerezleri nasıl kullandığımız hakkında daha fazla bilgi edinin',
      learnMoreLink: 'https://www.recright.com/en/cookies/',
      manageCookies: 'Çerezleri Yönet',
      acceptAll: 'Tüm Çerezleri Kabul Et',
      manageTitle: 'Onay tercihlerinizi yönetin',
      necessaryCookiesTitle: 'Gerekli çerezler',
      necessaryCookiesBody:
        'Bu çerezler, web sitesinin işlemesi için gerekli olan çerezlerdir ve sistemlerimizde kapatılması mümkün değildir.',
      performanceCookiesTitle: 'Performans çerezleri',
      performanceCookiesBody:
        'Bu çerezler, sitemizin performansını ölçebilmemiz ve iyileştirebilmemiz için ziyaretlerin ve trafik kaynaklarının sayısını hesaplamamıza olanak sağlamaktadır.',
      marketingCookiesTitle: 'Pazarlama çerezleri',
      marketingCookiesBody:
        'Bu çerezler, reklamları kişiye göre özelleştirmemize ve reklam performansını ölçmemize olanak sağlamaktadır.',
      functionalCookiesTitle: 'İşlevsellik çerezleri',
      functionalCookiesBody:
        'Bu çerezler, web sitesinin işlevselliğini geliştirmek için kullanılır. Bu çerezler olmadan belirli işlevler kullanılamayabilir. İşlevsel çerez örnekleri arasında web sohbet hizmetleri ve kullanıcı tercihleri bulunur',
      confirmChoices: 'Tercihlerimi Onayla',
    },

    formErrors: {
      typeNotWhitelisted: 'Üzgünüz, bu dosya türüne izin verilmiyor.',
      isRequired: 'Bu alan zorunludur.',
      isEmail: value => `${value} geçerli bir e-posta adresi değil.`,
      isDate: value => `${value} geçerli bir tarih değil.`,
      invalidUrl: 'URL geçersiz.',
      singleHireEndError: 'Tek kiralama en fazla 60 gün kullanılabilir.',
      isNotTooOldForLive: 'Geçmişte olan bir tarih girdiniz.',
      isNotAfterEndDate: 'Seçilen tarih, iş ilanının kapandığı tarihten sonra olamaz.',
      isValidMobilePhone: value => `${value ? `${value}` : ''} geçerli bir cep telefonu numarası değil.`,
      isInternationalPhoneNumber: 'Telefon numarası uluslararası formatta olmalıdır.',
      duplicateNumber: 'Telefon numarası daha önce eklendi.',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: 'Ad',
      city: 'Yaşadığı yer',
      email: 'E-posta',
      phone: 'Telefon numarası',
      applyForPosition: 'Pozisyon için başvur',
      back: 'Geri',
      continue: 'Devam et',
      submit: 'Gönder',
      saveForLater: 'Daha sonra devam et',
      namePlaceholder: 'Adınızı girin',
      emailPlaceholder: 'E-posta adresinizi girin',
      phonePlaceholder: 'Telefon numaranızı girin',
      cityPlaceholder: 'Şu anda yaşadığınız yeri girin',
      links: 'Link ekleyin, örneğin LinkedIn profiliniz',
      legendBasicInfo: 'Temel bilgiler',
      legendLinks: 'Linkler',
      legendAttachments: 'Ekler',
      legendAdditionalFields: 'Ek bilgi',
      coverLetter: 'Ön yazı',
      attachments: 'Ekler',
      introduction: 'Kısa tanıtım yazınızı buraya yazın',
      thankYou: 'Teşekkürler.',
      luck: 'İyi şanslar!',
      close: 'Kapat',
      required: '* (yıldız işareti) ile işaretlenmiş öğeler zorunludur.',
    },

    jobAdCard: {
      newApplications: 'Görünmeyen başvurular',
      responses: 'Başvurular',
    },

    jobAdContainer: {
      endTime: date => (date ? `Şu tarihe kadar açık: ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'İş başvurusu yap',
    },

    jobAdQuickInterview: {
      back: 'Geri',
      submit: 'Gönder',
      saveForLater: 'Daha sonra devam et',
      title: 'Hızlı video mülakat',
      description: 'Sizi daha hızlı tanımak için, hızlı mülakat sorumuzu kısaca cevaplamanızı rica ediyoruz. Kişiliğinizi yansıtın ve başvurunuza bir ruh kazandırın.',
      requiredNote: 'Bunun, başvuru sürecinin bir parçası olduğunu ve işe alım biriminin başvurunuzu ancak siz cevabınızı kaydettikten sonra alacağını unutmayın.',
      reminderNote: 'Cevabınızı hemen kaydedebilir veya e-postanıza gönderilecek bir hatırlatma mesajıyla daha sonra devam edebilirsiniz.',
    },

    jobAdRow: {
      responses: 'Başvurular',
      status: {
        open: 'Açık',
        filled: 'Dolu',
        cancelled: 'İptal edildi',
        done: 'Tamam',
        close: 'Kapat',
        draft: 'Kapalı (taslak)',
        hidden: 'Gizli',
      },
    },

    interviewRow: {
      responses: 'Adaylar',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'LinkedIn profilini göster',
    },

    linkedInButton: {
      error: 'Profil alınırken bir hata oluştu. Lütfen tekrar deneyin.',
      buttonText: 'LinkedIn ile başvur',
    },

    linkListInput: {
      addField: 'Ekle',
      removeField: 'Kaldır',
      invalidUrl: 'URL geçersiz.',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Başvuru formunu önceden doldurmak için LinkedIn profilinizi kullanabilirsiniz',
      linkedInOr: 'Veya',
      error: 'Profil alınırken bir hata oluştu. Lütfen tekrar deneyin.',
    },

    loadingButton: {
      loading: 'Yükleniyor...',
      saving: 'Kaydediliyor...',
      sending: 'Gönderiliyor...',
    },

    modalApplicationForm: {
      applyForPosition: 'Pozisyon için başvur',
      continue: 'Devam et',
      name: 'Adınızı girin',
      email: 'E-posta adresinizi girin',
      phoneNumber: 'Telefon numaranızı girin',
      links: 'Link girebilirsiniz',
      legendLinks: 'Linkler',
      legendAttachments: 'Ekler',
      coverLetter: 'Ön yazı',
      attachments: 'Ekler',
      introduction: 'Tanıtım yazınızı buraya yazın',
      thankYou: 'Teşekkürler.',
      luck: 'İyi şanslar!',
      close: 'Kapat',
    },

    modalConfirm: {
      cancel,
      confirm: 'Tamam',
    },

    modalAlert: {
      close: 'Kapat',
    },

    modalLinkShare: {
      title: 'Paylaşılabilir açık link',
      info: 'Paylaşabileceğiniz bir iş ilanının açık adresini veriyoruz.\nPozisyonla ilgilenen herkes iş ilanını görebilir \nve ardından başvuru yapıp yapmamaya karar verebilir.\nBaşvurular gelmeye başladığında size bildirim gönderilecektir.\n\nİş ilanı linkine şuradan ulaşabilirsiniz:',
    },

    modalVideoAdd: {
      chooseTitle: 'Yeni bir video ekle',
      title: 'Yeni bir video kaydet',
      titlePlaceholder: 'Video başlığını buraya girin',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Yeni bir video yükle',
      info: 'İzin verilen maksimum video boyutu 500 mb\'dir. Yüklemeden önce videoları sıkıştırmanızı öneririz, bu şekilde yükleme ve dönüştürme işlemi daha az zaman alacaktır.',
    },

    modalCandidateInfo: [
      {
        headline: 'Video yanıtınızı kaydedin ',
        content: 'dilediğiniz kadar. Videolar kaydedildikten hemen sonra kaydedilecektir ve e-posta adresinize gelen link üzerinden video mülakata geri dönebilirsiniz.',
        mobileContent: 'dilediğiniz kadar. Videoyu mülakata ekleyin. Videonun mülakata yüklendiğini ve kaydedildiğini göreceksiniz. E-posta adresinize gelen link üzerinden video mülakata geri dönebilirsiniz. <br><br><strong>Video ekranınız siyah kalırsa ve Apple markalı bir mobil cihaz kullanıyorsanız, sorunun nasıl çözüleceğine ilişkin talimatlara ulaşabilirsiniz <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">buradan</a>.</strong>',
      },
      {
        headline: 'Kaydettikten sonra, ',
        content: 'videonun doğru bir şekilde oynatıldığından ve sesinizin duyulabilir olduğundan emin olun. “Gönder” düğmesine bastığınızda cevabınız kilitlenecektir ve bu aşamadan sonra cevabınızı düzenleyemezsiniz.',
      },
      {
        headline: 'Mülakat sona erdiğinde, ',
        content: '“Cevapları gönder ve mülakatı tamamla” düğmesine basın. Bu aşamadan sonra video mülakata geri dönemezsiniz. Bu sayfayı kapatmak ve mülakata daha sonra devam etmek istiyorsanız, “Daha sonra devam et” düğmesine basın.',
      },
      {
        headline: 'Video mülakat sorularını cevaplama konusunda',
        content: mailto => `yardıma ihtiyacınız olursa, sayfanın sağ alt tarafındaki "yardım" düğmesine tıklayabilir ya da ${mailto} adresine e-posta gönderebilirsiniz.`,
        customContent: link => `İletişim için tıklayın: ${link}`,
      },
    ],

    navigationBar: {
      back: 'Geri',
      dashboard: 'Kontrol Paneli',
      frontpage: 'Ön sayfa',
    },

    personDetails: {
      stage: 'Aşama',
      namePlaceholder: 'Aday',
      contact: 'İletişim',
      links: 'Linkler',
      attachments: 'Ekler',
      coverLetter: 'Ön Yazı',
      referrer: 'Başlangıç noktası',
      referrerInfo: 'İş adayını bu hizmete yönlendiren web sitesi.',
      noStage: 'Henüz herhangi bir aşamada değil',
      lastSeen: time => `Son görülme zamanı: ${time}.`,
      headerAdditionalInformation: 'Ek bilgi',
      state: {
        invited: 'Davet edildi',
        visited: 'Ziyaret edildi',
        incomplete: 'Tamamlanmadı',
        completed: 'Tamamlandı',
      },
      notVisited: 'Henüz mülakatı ziyaret etmedi.',
      scheduledInterview: 'Toplantı bilgileri',
      scheduledInterviewInvitationSent: 'Toplantıya davet edildi',
      scheduledInterviewInvitationExpired: 'Davet süresi doldu',
      scheduledInterviewInvitationEventCreated: '',
      scheduledInterviewReScheduleMeeting: 'Toplantıyı yeniden planlayın',
      otherPersons: count => `Ayrıca ${count} pozisyonda daha bulundu`,
    },

    phoneInput: {
      placeholder: example => `Telefon formatı ${example}`,
    },

    questionsAndResponses: {
      response: 'Yanıt',
      noResponse: 'Yanıt yok',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
    },

    rating: {
      ownVote: 'Puanınız',
      yourVotePlaceholder: 'Henüz oylama yapmadınız.',
      totalVotes: count => `Toplam ${count} oy`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Oyunuzu sıfırlayın',
      averageRating: 'Ortalama puan',
      reset: 'sıfırla',
    },

    share: {
      share: 'Paylaş',
      copy: 'Linki kopyala',
    },

    sort: {
      sort: 'Sırala',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Seçildi',
      change: 'Değiştir',
    },

    video: {
      videoNotFound: 'Video işleniyor veya video bulunamadı',
      retry: 'Tekrar dene',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Yeni bir video yükle veya kaydet' : 'Dosya seç'),
      videoPlaceholder: 'Yanıtınızı kaydedin',
      uploadPlaceholderCandidate: 'Video yükleyin',
      submit: 'Yanıtı gönder',
      notAnswered: 'Henüz cevap vermediniz',
      remove: 'Almayı kaldır',
      converting: 'Video dönüştürülüyor. Lütfen bekleyin...',
      uploading: 'Video yükleniyor. Lütfen bekleyin...',
      error: {
        invalid: 'Seçilen dosya çok büyük. Lütfen başka bir dosya seçin.',
        upload: 'Üzgünüz, videoyu yükleyemedik. Lütfen tekrar deneyin.',
        transcode: 'Seçilen video dosyası bozuk veya geçerli değil, lütfen tekrar deneyin.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Daha az göster',
      showLessButtonText: 'Daha fazlasını göster',
      infoText1:
        'Kayıt yaparken sekmeyi ön planda etkin tutun. Kayıt yaparken başka bir uygulamayı kullanmanız gerekir.',
      infoText2:
        'Video arka plan videoları, en güncel tarayıcılarda ve nispeten yeni ve güçlü bir cihazda en iyi şekilde çalışır.',
      infoText3:
        'Diğer uygulamaların mikrofonunuzu veya kameranızı kullanmadığından emin olun.'
    },

    videoResponse: {
      videoPlaceholder: 'Yanıtınızı kaydedin',
      uploadPlaceholder: 'Video yükleyin',
      submit: 'Yanıtı gönder',
      notAnswered: 'Henüz cevap vermediniz',
      startInterview: 'Mülakata başla',
    },

    webcam: {
      useVideoBgButtonText: 'Video arka planını kullan',
      removeVideoBgButtonText: 'Video arka planını kaldır',
      starting: 'Başlatılıyor...',
      close: 'Kamerayı kapat',
      remove: 'Almayı kaldır',
      record: 'Kaydet',
      stop: 'Durdur',
      retake: 'Tekrar kaydet',
      submit: 'Yanıtı gönder',
      converting: 'Video dönüştürülüyor. Lütfen bekleyin...',
      uploading: 'Video yükleniyor. Lütfen bekleyin...',
      downloading: 'Video indiriliyor. Lütfen bekleyin...',
      processing: 'İşleniyor...',
      uploadInProgress: 'Video aktarma işlemi devam ediyor, tarayıcıyı kapatmayın veya sayfayı değiştirmeyin.',
      uploaded: 'Video aktarıldı.',
      error: {
        DevicesNotFoundError: 'Kamera veya mikrofon kullanılamıyor. Lütfen etkinleştirdiğinizden emin olun.',
        NotFoundError: 'Kamera veya mikrofon kullanılamıyor. Lütfen etkinleştirdiğinizden emin olun.',
        NotAllowedError: 'Kamerayı veya mikrofonu kullanma izni vermediniz.',
        PermissionDismissedError: 'İzin iletişim kutusunu reddettiniz. Kamera ve mikrofonu kullanmak için lütfen izin verin.',
        PermissionDeniedError: 'Kamera veya mikrofon erişimini reddettiniz.',
        NotReadableError: 'Kamera veya mikrofon akışı okunamıyor. Muhtemel donanım sorunu.',
        SecurityError: 'Güvenlik hatasından dolayı kamera veya mikrofon kullanılamıyor',
        stream: 'Bir hata oluştu. Lütfen tarayıcınızı yeniden başlatın. Sorun hala devam ederse, lütfen farklı bir tarayıcı kullanmayı deneyin.',
        download: 'Video indirme başarısız. Tekrar dene?',
        upload: 'Video yükleme başarısız. Tekrar dene?',
        emptyBlob: 'Tarayıcınızın veya cihazınızın belleği dolu olduğu için kayıt oluşturamıyor. Lütfen sayfayı yenileyin. İşe yaramazsa, tarayıcıyı yeniden başlatın.  Sorun hala devam ederse, lütfen farklı bir tarayıcı kullanmayı deneyin.',
        alternativeRecorder: 'Ayrıca buna tıklayarak da dosya yükleyebilirsiniz.',
        reconnecting: 'Bağlantı kesildi. Yeniden bağlantı deneniyor.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Merhaba! Sizi ${title} video mülakatına davet etmek istiyoruz! Bu davet, e-posta adresinize de gönderildi. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
